function isEmpty<T>(collection: string | object | T[]): boolean {
  return Object.keys(collection).length === 0;
}

export {
  // eslint-disable-next-line
  isEmpty
};
